theme.SlideShow = (function() {
  function Slider(e) { 
    let slideshow = e.querySelector(".slideshow__wrapper"),
        paginationSelector = e.querySelector('.swiper-pagination'),
        navselectorPrev = e.querySelector('.swiper-button-prev'),
        navselectorNext = e.querySelector('.swiper-button-next'),
        autoplaySelctor = e.dataset.sliderAutoplay,
        autoplayInit = false,
        autoPlayDelay = parseInt(e.dataset.sliderDelay),
        loopSelector = e.dataset.sliderLoop,
        loopInit = false,
        slidePagination = e.dataset.pagination,
        paginatinInit = "bullets";
    
    if(autoplaySelctor == "true"){
    	autoplayInit = 	{delay: autoPlayDelay}
    }
    
    if( loopSelector == "true"){
    	loopInit = true;
    }
    
    if(slidePagination == "counter"){
    	paginatinInit = "fraction"
    }
    
	function pauseSlideshowVideos(container) {
		container.querySelectorAll(".slideshow__media video").forEach(function (v) {
			v.pause();
		});
	}
	function playSlideshowActiveVideo(container) {
		pauseSlideshowVideos(container);
		var active = container.querySelector(".swiper-slide-active .slideshow__media video");
		if (active) {
			var p = active.play();
			if (p && typeof p.catch === "function") {
				p.catch(function () {});
			}
		}
	}

	var swiper = new Swiper(slideshow, {
      loop: loopInit,
      pagination: {
        el: paginationSelector,
        clickable: true,
        type: paginatinInit,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + "</span>";
        }
      },
      autoplay: autoplayInit,
      autoHeight: true,
      navigation: {
        nextEl: navselectorNext,
        prevEl: navselectorPrev,
      },
      on: {
        init: function () {
          playSlideshowActiveVideo(slideshow);
        },
        slideChangeTransitionEnd: function () {
          playSlideshowActiveVideo(slideshow);
        }
      }
    });
  }
  return Slider;
})();

